import React from 'react';
import classNames from 'classnames';
import BaseIcon from 'common/BaseIcon';

/**
 * @typedef {{
 *  id?: string,
 *  value: string,
 *  isLeft?: boolean,
 *  labelProps?: HTMLLabelElement,
 *  className?: import('classnames').Argument,
 *  classNameWrapper?: import('classnames').Argument,
 *  }} CheckboxProps
 */

/** @type {React.FC<CheckboxProps>} */
const Checkbox = ({ id, value, className, classNameWrapper, labelProps, isLeft = true, children, ...rest }) => (
  <div className={classNames(classNameWrapper, 'default-checkbox')}>
    <input
      id={id}
      type="checkbox"
      className={classNames(className, { left: isLeft, right: !isLeft })}
      checked={value}
      tabIndex={0}
      {...rest}
    />
    <label {...labelProps} htmlFor={id} aria-hidden="true">
      <BaseIcon icon="check" className={classNames('d-none fb-icon text-white checkbox__check', { left: isLeft, right: !isLeft })} />
      {children}
    </label>
  </div>
);

export default Checkbox;
